import { Component, Input } from "@angular/core";
import { Fiat } from "@models";

@Component({
	selector: "fiat-amount-tile",
	templateUrl: "./fiat-amount-tile.component.html",
	styleUrls: ["./fiat-amount-tile.component.scss"],
	standalone: false
})
export class FiatAmountTileComponent {
	@Input()
	public amount: number = 0;
	@Input()
	public fiat: Fiat = null;
	@Input()
	public max: string = null;
	@Input()
	public isSavings: boolean = false;
	@Input()
	public recurringFrequency: string = "";
}
